import React, { useState } from 'react';
import { Box } from '@mui/material';
import { useReservation } from '../context';
import { PageHeader } from '../components/ReservationList/PageHeader';
import { ReservationTable } from '../components/ReservationList/ReservationTable';
import { ErrorSnackbar } from '../components/ReservationList/ErrorSnackbar';
import { ModalDelete } from '../components/ReservationList/ModalDelete';
import type { Reservation } from '../../../shared/services/reservation/reservationService';

function ReservationListContent() {
  const { 
    reservations, 
    isLoading, 
    error, 
    handleCreate, 
    handleCloseError,
    navigateToEdit,
    openDeleteModal,
    handleView
  } = useReservation();

  const handleEdit = (reservation: Reservation) => {
    navigateToEdit(reservation.id);
  };

  const handleDelete = (reservation: Reservation) => {
    openDeleteModal(reservation);
  };

  return (
    <>
      <ErrorSnackbar error={error} onClose={handleCloseError} />

      <Box sx={{ p: 3 }}>
        <PageHeader onCreate={handleCreate} isLoading={isLoading} />
        <ReservationTable
          reservations={reservations}
          isLoading={isLoading}
          onView={handleView}
          onEdit={handleEdit}
          onDelete={handleDelete}
        />
      </Box>

      <ModalDelete />
    </>
  );
}

export default function ReservationListPage() {
  return <ReservationListContent />;
}